<template>
  <section class="about">
    <the-header></the-header>
    <h1>This is an about page</h1>
    <the-footer></the-footer>
  </section>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';

export default {
  name: 'about',
  components: {
    TheHeader,
    TheFooter,
  },
};
</script>

<style lang="scss" scoped>

</style>
